module.exports = [{"type":"hash","text":"Connection Limits"},{"type":"normal","text":"A single websocket is limited to a maximum of 200 topics; exceeding this will return error code 100416."},{"type":"normal","text":"A single IP is limited to a maximum of 60 websockets; exceeding this will return error code 100419."}]


//////////////////
// WEBPACK FOOTER
// ./src/config/en-US/spot/websocket/introduce/01_limit.json
// module id = +dFG
// module chunks = 3